//own imports
import  DarkModeToggle  from '../../common/toggleSwitch/DarkModeToggle'
import './Settings.css'

//react imports
import React, {
    useEffect,
} from 'react';

const Settings = () => {

    //Page title
    useEffect(() => {
        document.title = 'Settings';
    }, []);

    return (
        <div style={{ minHeight: '100vh' }}>
            <h1 className="header">Settings</h1>
            <div className="settings-container" >
                <div className="setting-element">
                    <div className="setting-element-left">Push Notifications</div>
                    <p className="setting-element-right">Coming soon</p>
                </div>
                <div className="setting-element">
                    <div className="setting-element-left">Dark Mode</div>
                    <DarkModeToggle className="setting-element-right"></DarkModeToggle>
                </div>
            </div>
           </div>
    ); 
};

export default Settings;